import { createContext, useCallback, useContext, useState } from "react";
import Notification from "../widjets/notification/Notification";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const showNotification = useCallback((message, type = "info", show = true) => {
        const id = Date.now() + Math.random().toString(36);
        setNotifications(prev => [...prev, {id, message, type, show}]);
    }, []);

    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}

            {notifications.map(notification => (
                <Notification 
                    key={notification.id}
                    message={notification.message}
                    type={notification.type}
                    removeNotification={() => removeNotification(notification.id)}
                />
            ))}
        </NotificationContext.Provider>
    );
};

export const UseNotification = () => {
    return useContext(NotificationContext);
};